module.exports = __webpack_public_path__ + "01_glasses_black.992d35c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/01_glasses_black.png
// module id = Ewb+
// module chunks = 0